import { Menu, Sidebar } from 'twyne-new.ui';

import { useAppLayoutContext } from './context';
import { useCollapseOnMobile } from './hooks';

export default function AppSidebar({ children }) {
  const { sidebarCollapse, setMenuCollapsed } = useAppLayoutContext()
  useCollapseOnMobile({ setCollapsed: setMenuCollapsed })

  return <div className="shrink-0">
    <Sidebar collapse={sidebarCollapse}>
      <Menu>
        {children}
      </Menu>
    </Sidebar>
  </div>
}
